import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '@app/shared/services/storage/local-storage.service';
import { Observable } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { ApiService } from './api.service';
import { NullableDate } from '@app/shared/models/nullable';
@Injectable({
  providedIn: 'root',
})
export class MunicipalityRestrictionsService extends ApiService {
  constructor(public http: HttpClient, public localStorageService: LocalStorageService) {
    super(http);
  }
  baseUri = 'socrates/authz/api/municipalities';

  public getByMunicpalityId(municipalityId: string): Observable<MunicipalityRestriction[]> {
    return this.http.get<MunicipalityRestriction[]>(this.endpoint(this.baseUri, `${municipalityId}/restrictions?$filter=isDeleted eq false`));
  }

  public getByPermissionId(municipalityId: string, permissionId: string): Observable<MunicipalityRestriction[]> {
    return this.http
      .get<MunicipalityRestriction[]>(
        this.endpoint(this.baseUri, `${municipalityId}/restrictions?$filter=permission/guid eq ${permissionId} and isDeleted eq false`)
      )
      .pipe(distinctUntilChanged(), shareReplay());
  }

  public getByPermissionCode(municipalityId: string, permissionCode: string): Observable<MunicipalityRestriction[]> {
    return this.http
      .get<MunicipalityRestriction[]>(
        this.endpoint(this.baseUri, `${municipalityId}/restrictions?$filter=permission/code eq '${permissionCode}' and isDeleted eq false`)
      )
      .pipe(distinctUntilChanged(), shareReplay());
  }

  public post(municipalityRestriction: MunicipalityRestriction): Observable<MunicipalityRestriction> {
    return this.http.post<MunicipalityRestriction>(
      this.endpoint(this.baseUri, `${municipalityRestriction.municipalityId}/restrictions/${municipalityRestriction.permissionId}`),
      municipalityRestriction
    );
  }

  public patch(municipalityGuid: string, restrictionId: string, municipalityRestriction: MunicipalityRestriction): Observable<MunicipalityRestriction> {
    return this.http.patch<MunicipalityRestriction>(this.endpoint(this.baseUri, `${municipalityGuid}/restrictions/${restrictionId}`), municipalityRestriction);
  }

  public delete(municipalityId: string, guid: string) {
    return this.http.delete(this.endpoint(this.baseUri, `${municipalityId}/restrictions/${guid}`));
  }
}

export interface MunicipalityRestriction {
  guid?: string;
  municipalityId: string;
  permissionId: string;
  isTeaser: boolean;
  modifyUser?: string;
  modifyDate?: string | NullableDate;
  creationUser?: string;
  creationDate: string | Date;
}
